import { useEffect } from "react";
import { IoMdAddCircle } from "react-icons/io";
import { MdPending } from "react-icons/md";
import { useSelector } from "react-redux";
import { LoadingSpinner, ProductMenuList } from "../components";
import styles from "../styles/productMenuLayout.module.css";

export const ProductMenuLayout = ({ children, handleAddProduct, actions }: ProductMenuLayoutProps) => {
  const { isLoading, products, product } = useSelector((state: any) => state.product);
  const { activeBusiness, businessType } = useSelector((state: any) => state.business);

  useEffect(() => {
    fetchProducts();
    console.log(businessType, "businessType");
  }, [activeBusiness]);

  const fetchProducts = async () => {
    await actions.get();
  };

  return (
    <div className={styles.wrapper}>
      {/* HEADER AND ACTIONS */}
      <div className={styles.header}>
        <h2>{businessType === "brand" ? "Products" : "Menu"}</h2>
        <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          {businessType === "venue" && (
            <button>
              <MdPending />
              Pending
            </button>
          )}
          <button onClick={handleAddProduct}>
            <IoMdAddCircle />
            Add Product
          </button>
        </div>
      </div>
      {/* SEARCH AND FILTER */}
      <div className={styles.searchFilterWrapper}>
        <div className={styles.search}>
          {/* TODO: TURN THIS INPUT HERE AND MENUADDPRODUCTMODAL INTO REUSABLE */}
          <input type="text" placeholder="Search" />
        </div>
      </div>

      {isLoading && <LoadingSpinner />}
      {/* PRODUCT LIST HEADER */}
      <div className={styles.listWrapper}>
        <ProductMenuList actions={actions} products={products} businessType={businessType} />
      </div>
      {children}
    </div>
  );
};
